import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ArticlePanier from '../composants/ArticlePanier';
import { usePanier } from '../contexte/PanierContexte';
import { formaterPrix } from '../services/format';

export default function Panier() {
  const navigate = useNavigate();
  const { items, total, changerQuantite, supprimer, vider } = usePanier();

  return (
    <div className="grid gap-6 px-2 py-4 sm:px-0 lg:grid-cols-[1fr_380px]">
      <section className="grid gap-4">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <div className="text-xs font-semibold uppercase tracking-widest text-gray-600">Panier</div>
            <div className="mt-2 text-xl font-bold text-gray-900">Vos articles</div>
          </div>
          {items.length ? (
            <button onClick={vider} className="text-sm text-gray-600 hover:text-gray-900">
              Vider
            </button>
          ) : null}
        </div>

        {items.length ? (
          items.map((it) => (
            <ArticlePanier
              key={`${it.produit_id}-${it.variante_id || 0}`}
              item={it}
              onChangeQuantite={(q) => changerQuantite({ produit_id: it.produit_id, variante_id: it.variante_id, quantite: q })}
              onSupprimer={() => supprimer({ produit_id: it.produit_id, variante_id: it.variante_id })}
            />
          ))
        ) : (
          <div className="rounded-3xl border border-gray-200 bg-white p-8 text-sm text-gray-600">
            Votre panier est vide.
            <div className="mt-4">
              <Link to="/" className="text-marega-700 hover:text-marega-800">
                Retour au catalogue
              </Link>
            </div>
          </div>
        )}
      </section>

      <aside className="h-fit rounded-3xl border border-gray-200 bg-white p-6 lg:sticky lg:top-28">
        <div className="text-sm font-semibold text-gray-900">Résumé</div>
        <div className="mt-4 flex items-center justify-between text-sm text-gray-700">
          <div>Total</div>
          <div className="text-lg font-bold text-gray-900">{formaterPrix(total)}</div>
        </div>

        <button
          onClick={() => navigate('/paiement')}
          disabled={!items.length}
          className="mt-6 w-full rounded-2xl bg-marega-600 px-5 py-4 text-sm font-semibold text-white shadow-lg shadow-marega-600/20 hover:bg-marega-500 disabled:opacity-50"
        >
          Passer au paiement
        </button>

        <div className="mt-4 text-xs text-gray-500">Paiement sécurisé par Stripe ou Mobile Money.</div>
      </aside>
    </div>
  );
}
